/**
 * Created by Ricardo on 7/24/2017.
 */
angular.module('ngLocalStorage', [])

    .factory('$localStorage', [function () {
        return {
            setKey: function (key, object) {
                var strObject = object == null ? null : JSON.stringify(object);
                localStorage.setItem(key, strObject);
            },

            getKey: function (key) {
                var storedValue = localStorage[key];
                return storedValue == null ? null : JSON.parse(storedValue);
            },
            destroyKey: function (key) {
                return localStorage.removeItem(key);
            }

        }
    }]);